// src/components/Shop.js
import React, { useContext, useState } from 'react';
import Sidebar from './Sidebar';
import ProductList from './ProductList';
import { ProductsContext } from '../App';

const Shop = React.memo(() => {
  const { products, setSearchQuery } = useContext(ProductsContext);
  const [category, setCategory] = useState('All');
  const [sort, setSort] = useState('price-low');

  return (
    <div style={{ display: 'flex', padding: '0 2rem' }} className="shop-container">
      <Sidebar
        onCategoryChange={setCategory}
        onSortChange={setSort}
        clearSearch={() => setSearchQuery('')} // <-- clears the global searchQuery
      />
      <main style={{ flex: 1, padding: '2rem' }}>
        <h2>Shop</h2>
        <ProductList products={products} category={category} sort={sort} />
      </main>
    </div>
  );
});

export default Shop;
